import newColors from "@/styles/newColors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	clickedChip: {
		fontWeight: 600,
		backgroundColor: newColors.grey[500],
		color: newColors.grey[0]
	},
	notSentMessageChip: {
		fontWeight: 500,
		backgroundColor: newColors.grey[100],
		color: newColors.grey[400]
	},
	sentMessageChip: {
		fontWeight: 600,
		backgroundColor: newColors.green[100],
		color: newColors.green[700]
	}
}))

export default useStyles
